import { get } from 'lodash-es'

import APP_CONFIG_CONSTANTS from '@/js/helper/app-config-constants'

import { types as STORE_MODULES } from '@/js/plugins/store/store-modules'
import ACTION_TYPES from '@/js/plugins/store/modules/aimeos/actions/actions-types'

export default store => {
  const APP = STORE_MODULES.APP
  const AIMEOS = STORE_MODULES.AIMEOS
  // console.log('optionsPromise plugin')
  // console.log(store.state[`${AIMEOS}`].optionsPromise)
  // store.watch(
  //   state => state[`${AIMEOS}`].optionsPromise,
  //   (newValue, oldValue) => {
  //     console.log('optionsPromiseWatcher')
  //     console.log(newValue, oldValue)
  //   },
  // )

  const optionsUrl = get(store, `state.${APP}.${APP_CONFIG_CONSTANTS.PATHS.AIMEOS_JSON_API_LINK}`)

  if (optionsUrl) {
    store.dispatch(`${AIMEOS}/${ACTION_TYPES.SET_OPTIONS_URL}`, optionsUrl)
  }
}
